export { default } from './CompareCharts';
